<div class="modal-body" style="background-color: #f3f3f3; padding: 20px;">
    <div class="text-center pt-3 pb-2">
      <span class="iconify" data-icon="carbon:information" style="font-size: 65px; color: #E7BB0B;"></span>
      <div class="mt-3 mb-4" style="color: #333;">{{ body }}</div>
      <div class="d-flex align-items-center justify-content-between">
        <button *ngIf="showCancel" (click)="close()" type="button" class="btn btn-danger" style="background-color: #FF5733; border-color: #FF5733;">{{ negativeButtonText }}</button>
  
        <i class="fa " [ngClass]="{'fa-spinner fa-spin': loading}" style="font-size: 30px; color: #FF5733;"></i>
        <button type="button" class="btn btn-primary" (click)="confirm()" style="background-color: #1E90FF; border-color: #1E90FF;">{{ positiveButtonText }}</button>
      </div>
    </div>
  </div>
  